const getWishlisted = (sku, items) => {
  const isWishlisted = items?.find((item) => item.sku === sku);
  return !!isWishlisted;
};
export {
  getWishlisted
};
//# sourceMappingURL=get-wishlisted.js.map
